import script from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=08be2c94&lang=scss"

const __exports__ = script;

export default __exports__